import {
  getAssignedDepartmentList,
  getDepartmentNamesArray,
  getItemOrDefaultToValue,
  getPersonName,
  getPhoneNumber,
} from '../../details';
//import BusinessClient from 'containers/ManagerialView/Panels/BusinessClient';

export const transformList = (data, globalDepartmentList = []) => {
  return data.map(bizClient => ({
    id: bizClient.id,
    archived: bizClient.archived,
    name: getItemOrDefaultToValue(bizClient, 'name', '-'),
    businessClientId: getItemOrDefaultToValue(
      bizClient,
      'businessClientId',
      '-',
    ),
    contactName:
      bizClient.contact !== null
        ? getPersonName(
            getItemOrDefaultToValue(bizClient.contact, 'general', '-'),
          )
        : '-',
    contactPhone:
      bizClient.contact !== null
        ? getPhoneNumber(
            getItemOrDefaultToValue(
              bizClient.contact.general,
              'phoneNumber',
              '-',
            ),
          )
        : '-',
    email:
      bizClient.contact !== null
        ? getItemOrDefaultToValue(bizClient.contact.general, 'email', '-')
        : '-',
    // this gives array of string names
    departments:
      bizClient?.departmentIds && globalDepartmentList.length > 0
        ? getDepartmentNamesArray(globalDepartmentList, bizClient)
        : [],
    // this give array of objects with string name and ids
    assignedDepartmentList:
      bizClient?.departmentIds && globalDepartmentList.length > 0
        ? getAssignedDepartmentList(globalDepartmentList, bizClient)
        : [],
  }));
};
